import styled from "styled-components";

import { FlexRow } from "@similarweb/ui-components";

export const StyledAppCategoryFilterResult = styled(FlexRow)`
    flex-wrap: wrap;
`;

export const StyledAppCategoryFilterContainer = styled.div`
    display: flex;
`;
